export default "__VITE_ASSET__Bv5PN7qE__"